import { render, staticRenderFns } from "./RemoveCategoryModal.vue?vue&type=template&id=4e71a15c&"
import script from "./RemoveCategoryModal.vue?vue&type=script&lang=js&"
export * from "./RemoveCategoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports